import { Container, Grid, Grow, Paper, AppBar, TextField, Button, InputAdornment, IconButton } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getPostsBySearch } from "../../actions/posts";
import { Posts, Forms, TagsInput } from "../index";
import Pagination from "../Pagination";
import { useNavigate, useLocation } from "react-router-dom";

import useStyles from "./styles";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Home = () => {
  const [currentId, setCurrentId] = useState(0);
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const navigate = useNavigate();
  const page = query.get("page") || 1;
  const searchQuery = query.get("searchQuery");

  const [search, setSearch] = useState("");
  const [tags, setTags] = useState("");

  /* useEffect(() => {
    dispatch(getPosts());
  }, [currentId, dispatch]); */

  const searchPost = () => {
    if (!search && !tags.length) {
      navigate("/posts");
    } else {
      if (search.trim() || tags) {
        dispatch(getPostsBySearch({ search, tags: tags.join(",") }));
        navigate(`/posts/search?searchQuery=${search || "none"}&tags=${tags.join(",")}`);
      } else {
        navigate("/posts");
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === `Enter`) {
      searchPost();
    }
  };

  function handleSelecetedTags(items) {
    setTags(items);
  }

  return (
    <Grow in>
      <Container maxWidth={"xl"}>
        <Grid
          container
          className={classes.gridContainer}
          justifyContent="space-between"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} sm={6} md={9}>
            <Posts setCurrentId={setCurrentId} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBar className={classes.appBarSearch} position={"static"} color={"inherit"}>
              <TextField
                name={"search"}
                variant="outlined"
                label="Search Note"
                placeholder="Press enter"
                fullWidth
                autoFocus
                onKeyDown={(e) => handleKeyPress(e)}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={searchPost} className={classes.endAdornment}>
                        <i className="bi bi-arrow-right-square-fill"></i>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TagsInput
                selectedTags={handleSelecetedTags}
                fullWidth
                variant="outlined"
                id="tags"
                name="tags"
                placeholder="add Tags"
                label="tags"
              />
              <Button
                onClick={searchPost}
                className={classes.buttonSubmit}
                color="primary"
                variant="contained"
                endIcon={<i className="bi bi-search"></i>}
              >
                Search
              </Button>
            </AppBar>
            <Forms currentId={currentId} setCurrentId={setCurrentId} />
            {!searchQuery && !tags.length && (
              <Paper className={classes.pagination} elevation={6}>
                <Pagination page={page} />
              </Paper>
            )}
          </Grid>
        </Grid>
      </Container>
    </Grow>
  );
};

export default Home;
